<template>
  <Wrapper v-if="showTutorial">
    <Outer :position="position" :direction="direction">
      <div>
        <OutlineFocus class="outline-focus"></OutlineFocus>
        <b-card-group deck>
          <b-card
            id="outline-card"
            style="max-width: 40vw"
            :header="card && card.title"
            header-tag="header"
            footer="Card Footer"
            footer-tag="footer"
            :title="card && card.title"
          >
            <b-card-text>Header and footers using props.</b-card-text>
            <b-button href="#" variant="blue" @click="next">Next</b-button>
          </b-card>
        </b-card-group>
      </div>
    </Outer>
  </Wrapper>
</template>

<script>
import styled from "vue-styled-components";

const Wrapper = styled.div``;
const OuterProps = {
  position: Object,
  direction: String,
};
const cardPosition = ({ position, direction = "right" }) => {
  switch (direction) {
    case "right":
      return {
        x: position.x + position.width + 10,
        y: position.y,
      };
    case "left":
      return {
        x: position.x - position.cardWidth - 10,
        y: position.y,
      };
    case "top":
      return {
        x: position.x,
        y: position.y - position.cardHeight - 10,
      };
    case "bottom":
      return {
        x: position.x,
        y: position.y + position.height + 10,
      };

    default:
      break;
  }
};

const Outer = styled("div", OuterProps)`
  position: fixed;
  display: block;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 10000;
  width: 100%;
  height: 100%;

  .card-deck {
    transition: all 0.2s ease;
    position: absolute;
    z-index: 10010;
    left: ${({ position, direction }) =>
      cardPosition({ position, direction }).x}px;
    top: ${({ position, direction }) =>
      cardPosition({ position, direction }).y}px;
    width: 100%;
  }
  .outline-focus {
    transition: all 0.2s ease;
    left: ${({ position }) => position.x}px;
    top: ${({ position }) => position.y}px;
    width: ${({ position }) => position.width}px;
    height: ${({ position }) => position.height}px;
    box-shadow: 0px 0px 0px 3px yellow, rgb(0 0 0 / 40%) 0px 0px 0px 200vw;
    border-radius: 4px;

    position: absolute;
    z-index: 10000;
  }
`;

const OutlineFocus = styled.div``;
export default {
  components: {
    Wrapper,
    OutlineFocus,
    Outer,
  },
  data() {
    return {
      card: {
        title: "",
      },
      showTutorial: false,
      position: {},
      direction: "right",
      runIndex: 0,
      countFetchPosition: 0,
    };
  },
  methods: {
    setPosition() {
      if (this.data[this.runIndex].url) {
        location.hash = this.data[this.runIndex].url;
        this.$store.dispatch("design/setActiveElement");
        this.next();
      } else {
        this.card = this.data[this.runIndex].card;
        this.$nextTick(function () {
          const target = document.querySelector(
            this.data[this.runIndex].selector
          );
          if (target) {
            const Rect = target.getBoundingClientRect();
            const card = document.getElementById("outline-card");
            const RectCard = card.getBoundingClientRect();
            this.direction = this.data[this.runIndex].direction;
            if (Rect.x !== 0 || Rect.y !== 0) {
              this.position = {
                x: Rect.x,
                y: Rect.y,
                width: Rect.width,
                height: Rect.height,
                cardWidth: RectCard.width,
                cardHeight: RectCard.height,
              };
            }
          }
          const current_index = this.runIndex;
          setTimeout(() => {
            if (
              this.runIndex === current_index &&
              this.countFetchPosition < 5
            ) {
              this.setPosition();
              this.countFetchPosition += 1;
            } else {
              this.countFetchPosition = 0;
            }
          }, 500);
        });
      }
    },
    init() {
      this.runIndex = 0;
      this.showTutorial = true;
      this.$nextTick(function () {
        this.setPosition();
      });
    },
    next() {
      if (this.runIndex === this.data.length - 1) {
        this.showTutorial = false;
      } else {
        this.runIndex += 1;
        this.setPosition();
      }
    },
  },
  props: {
    data: {
      type: Array,
    },
  },
};
</script>

<style>
</style>